var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Savable } from '@/common/mixins/Savable';
import PlainTextControl from '@/common/components/PlainTextControl.vue';
import TextAreaControl from '@/common/components/TextAreaControl.vue';
import TooltipIcon from '@/common/components/TooltipIcon.vue';
import CheckBoxControl from '@/common/components/CheckBoxControl.vue';
import CheckBoxDialogRow from '@/common/components/CheckBoxDialogRow.vue';
import NumericInputTableCell from '@/common/components/NumericInputTableCell.vue';
import NumericInputControl from '@/common/components/NumericInputControl.vue';
import SingleSelectTableCell from '@/common/components/SingleSelectTableCell.vue';
import { Focusable } from '@/common/mixins/Focusable';
import { EnumHelpers } from "@/common/mixins/EnumHelpers";
import { Validatable } from '@/common/mixins/Validatable';
import { ValidationProvider } from 'vee-validate';
import { CollectionMethod } from '@/common/types/CollectionType';
var TargetGroupAndOperationTable = /** @class */ (function (_super) {
    __extends(TargetGroupAndOperationTable, _super);
    function TargetGroupAndOperationTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.numberInputPlaceholderKey = "EnterValue";
        return _this;
    }
    Object.defineProperty(TargetGroupAndOperationTable.prototype, "showDeleteBtn", {
        get: function () {
            return this.items && this.items.length > 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TargetGroupAndOperationTable.prototype, "CollectionMethod", {
        get: function () {
            return CollectionMethod;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TargetGroupAndOperationTable.prototype, "buttonTitle", {
        get: function () {
            return "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.AddOperation";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TargetGroupAndOperationTable.prototype, "hasTargets", {
        get: function () {
            return this.targets && this.targets.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    TargetGroupAndOperationTable.prototype.addRow = function () {
        return __awaiter(this, void 0, void 0, function () {
            var focusTarget;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.addNewRow(this.items);
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        focusTarget = "operationtype_" + this.tableIndex + "_" + (this.items.length - 1);
                        this.focusOnComponentId(focusTarget);
                        return [2 /*return*/];
                }
            });
        });
    };
    TargetGroupAndOperationTable.prototype.deleteRow = function (index) {
        if (confirm(this.$i18n.t("Confirmation.DeleteRow").toString())) {
            this.items.splice(index, 1);
            this.forceSave();
        }
    };
    TargetGroupAndOperationTable.prototype.setDistributionVisibility = function (item) {
        if (item.collectionMethod != CollectionMethod.Collected && item.collectionMethod != CollectionMethod.Sampling) {
            if (item.hasAgeGenderDistribution) {
                this.setItemHasDistribution(item, false);
            }
        }
    };
    TargetGroupAndOperationTable.prototype.setItemHasDistribution = function (item, value) {
        if (value) {
            item.ageGenderDistribution = this.createNewAgeGenderDistribution();
            item.hasAgeGenderDistribution = true;
        }
        else {
            item.ageGenderDistribution = null;
            item.peopleTurnover = null;
            item.hasAgeGenderDistribution = false;
        }
        this.forceSave();
    };
    TargetGroupAndOperationTable.prototype.getId = function (name, index) {
        return name + "" + index;
    };
    TargetGroupAndOperationTable.prototype.addNewRow = function (arr) {
        var item = {
            operationType: null,
            description: null,
            targets: [],
            operationCount: null,
            collectionMethod: null,
            encounterCount: null,
            callAttempts: null,
            hasAgeGenderDistribution: null,
            ageGenderDistribution: null,
            peopleTurnover: null
        };
        arr.push(item);
        this.forceSave();
    };
    TargetGroupAndOperationTable.prototype.showModal = function (index) {
        this.$bvModal.show("targets_" + this.tableIndex + "_" + index + "-modal");
    };
    TargetGroupAndOperationTable.prototype.createNewAgeGenderDistribution = function () {
        return {
            men: this.createAgeGenderDistributionRow(),
            women: this.createAgeGenderDistributionRow(),
            other: this.createAgeGenderDistributionRow()
        };
    };
    TargetGroupAndOperationTable.prototype.createAgeGenderDistributionRow = function () {
        return {
            ages0to5: null,
            ages6to17: null,
            ages18to24: null,
            ages25to35: null,
            ages36to45: null,
            ages46to55: null,
            ages56to65: null,
            ages66to75: null,
            ages76plus: null
        };
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TargetGroupAndOperationTable.prototype, "title", void 0);
    __decorate([
        Prop(Array),
        __metadata("design:type", Array)
    ], TargetGroupAndOperationTable.prototype, "items", void 0);
    __decorate([
        Prop(Array),
        __metadata("design:type", Array)
    ], TargetGroupAndOperationTable.prototype, "targets", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], TargetGroupAndOperationTable.prototype, "tableIndex", void 0);
    TargetGroupAndOperationTable = __decorate([
        Component({
            name: "TargetGroupAndOperationTable",
            components: {
                PlainTextControl: PlainTextControl,
                TextAreaControl: TextAreaControl,
                CheckBoxControl: CheckBoxControl,
                CheckBoxDialogRow: CheckBoxDialogRow,
                NumericInputTableCell: NumericInputTableCell,
                NumericInputControl: NumericInputControl,
                TooltipIcon: TooltipIcon,
                SingleSelectTableCell: SingleSelectTableCell,
                ValidationProvider: ValidationProvider
            }
        })
    ], TargetGroupAndOperationTable);
    return TargetGroupAndOperationTable;
}(Mixins(Savable, Focusable, EnumHelpers, Validatable)));
export default TargetGroupAndOperationTable;
